import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const ProjectSelection = (props) => {
  const [elements, setElements] = useState(props.initialValue || []);
  // State to control what's shown in the select box
  const [selectedValue, setSelectedValue] = useState('');

  useEffect(() => {
    setElements(props.initialValue || []);
  }, [props.initialValue]);

  const simulateEvent = (value) => ({
    target: { name: props.name, value },
  });

  const onChange = ({ target }) => {
    const { value } = target;

    // A value was selected from the dropdown
    if (value && !elements.includes(value)) {
      const newElements = [...elements, value];
      setElements(newElements);
      props.onChange(simulateEvent(newElements));
    }
    // Update the select box to show the selected value
    setSelectedValue(value);
  };

  const onRemoveClick = (element) => () => {
    const updatedElements = elements.filter((e) => e !== element);
    setElements(updatedElements);
    props.onChange(simulateEvent(updatedElements));

    // If the removed tag is the one currently displayed in the select box, clear it
    if (selectedValue === element) {
      setSelectedValue('');
    }
  };

  // Options available in the dropdown should not include already selected ones
  const availableOptions = props.options.filter((o) => !elements.includes(o));

  const options = availableOptions.map((o) => (
    <option key={o} value={o}>
      {o}
    </option>
  ));

  const currentValues = elements.map((e) => (
    <span key={e} className="list-input-element">
      <strong>{e}</strong>
      <button onClick={onRemoveClick(e)} className="btn">
        ×
      </button>
    </span>
  ));

  const placeholder = props.placeholder || 'Select...';

  return (
    <React.Fragment>
      <select
        className="form-control"
        name={props.name}
        onChange={onChange}
        value={selectedValue} // This is controlled by state now
      >
        <option value="">{placeholder}</option>
        {options}
      </select>

      <div className="list-input-values">{currentValues}</div>
    </React.Fragment>
  );
};

ProjectSelection.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
  initialValue: PropTypes.arrayOf(PropTypes.string),
  placeholder: PropTypes.string,
};

ProjectSelection.defaultProps = {
  initialValue: [],
  placeholder: 'Select...',
};

export default ProjectSelection;
